import Vue from 'vue'
import Vuex from 'vuex'
import API from '@/api/api-class'
import auth from '@/store/modules/auth'
import self from '@/store/modules/self'
import teams from '@/store/modules/teams'
import users from '@/store/modules/users'
import media from '@/store/modules/media'
import inboxes from '@/store/modules/inboxes'
import traceTokens from '@/store/modules/traceTokens'
import plans from '@/store/modules/plans'
import reportTypes from '@/store/modules/reportTypes'
import exportTypes from '@/store/modules/exportTypes'
import outlets from '@/store/modules/outlets'
import addons from '@/store/modules/addons'
import roles from '@/store/modules/roles'

Vue.use(Vuex)

const protocol = 'https:'
// Smart api calls
const newsbxAPI = new API({ url: `${protocol}//${process.env.VUE_APP_SERVER_URL}` })

export const actions = {
  async handleRequestResponse ({ commit, state }, { mutation, request }) {
    commit(mutation, await request)
  },
  async handleRequest ({ commit, dispatch, state }, params = {}) {
    let { name, action, mutation, data, tokenScope } = params
    let match = name.match(/\bauth/g)
    if (match === null) {
      name = `api/v1/${name}`
    }
    if (!data) {
      data = {}
    }
    if (!mutation) {
      mutation = null
    }
    if (!tokenScope) {
      tokenScope = 'operator'
    }
    commit('SET_TOKEN_SCOPE', tokenScope)
    newsbxAPI.createEntity({ name })
    const request = newsbxAPI.endpoints[name][action](data)
    if (mutation !== null) {
      await dispatch('handleRequestResponse', { mutation, request })
    } else {
      return request
    }
  }
}

export const modules = {
  auth,
  self,
  teams,
  users,
  media,
  inboxes,
  traceTokens,
  plans,
  reportTypes,
  exportTypes,
  outlets,
  addons,
  roles
}

export const store = new Vuex.Store({
  actions,
  modules
})
